import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { CategoriesRequest } from './categoriesrequest';

export class CategoriesAPI extends APIImpl<CategoriesRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/categories
        return "categories"+"?language="+ this.getRequest().getCategoriesRequest().getLanguage();
    }
    
    getRequestData()
    {
        //return "language="+ this.getRequest().getCategoriesRequest().getLanguage();
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/categories/categoriesapi.tsx